import api from "../api/index.js";

class TabItem {
  constructor(name, displayName, expData) {
    /**
     * 名称
     */
    this.name = name
    /**
     * 显示名称
     */
    this.displayName = displayName


    let isStatistic = false
    // TODO:运行分析默认数据项单位
    const unitObj = {
      101: 'V',
      102: 'A',
      103: 'kW',
      201: 'V',
      202: 'V',
      203: 'V',
      204: 'V',
      205: 'V',
      206: 'V',
      207: 'A',
      208: 'A',
      209: 'A',
      210: 'A',
      211: 'kW',
      212: 'kW',
      213: 'kW',
      214: 'kW',
      215: 'kW',
      216: 'kW',
      217: 'kW',
      218: 'kW',
      219: '',
      220: '',
      221: '',
      222: '',
      223: '',
      224: '',
      225: '',
      226: '',
      227: 'Hz',
      228: '',
      229: '',
      230: '',
      231: '',
      232: '',
      233: '%',
      234: '',
      235: '%',
      242: '%',
      243: '%',
      249: 'V',
      250: 'V',
      251: 'V',

      403: 'm³',
      404: 'Pa',
      405: 'kg/m³',
      406: '',
      407: '',
      408: '',
      409: '',
      501: '°C',
      502: '',
      601: '',
    }

    for (let i = 0; i < expData.length; i++) {
      if (expData[i].dataType !== 'measuring') {
        isStatistic = true
      }
      if (!expData[i].unit) {
        if (unitObj[expData[i].pointCode]) {
          expData[i].unit = unitObj[expData[i].pointCode]
        } else {
          expData[i].unit = ''
        }
      }
    }
    /**
     * 是否为统计项,  true  不显示数据类型选择
     */
    this.isStatistic = isStatistic

    /**
     * 数据项
     */
    this.expData = expData
  }
}

/**
 * 判断该pointCode是否可用于运行分析
 * @param {*} pointCode 
 */
function judgePointCode (pointCode) {
  // 排除谐波量
  if (pointCode <= 40000 && pointCode >= 10000) {
    return false
  }
  return true
}

/**
 * 
 * @param {*} pointCode 
 */
function getPointCodeDataType (pointCode) {
  const code = {
    quantity: [100229, 100230, 100231, 100232, 100401, 100402, 100701, 100801, 233],
    measuring: [101, 102, 103, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 234, 235, 242, 243, 249, 250, 251, 401, 402, 403, 404, 405, 406, 407, 408, 409, 501, 502, 601, 701]
  }
  let ret = 'quantity'
  for (const key in code) {
    for (let i = 0; i < code[key].length; i++) {
      if (code[key][i] == pointCode) {
        return key
      }
    }
  }
  return ret
}

async function loadAllMeasuringData (measures, startTime, endTime, allMeasuringData) {
  const res = await api.measuring.getMeasuringValueAll2(measures, startTime, endTime, 0, 5000)
  for (let i = 0; i < res.data.length; i++) {
    const element = res.data[i];
    if (!allMeasuringData[toKey(element.pointCode, element.pointNumber)]) {
      allMeasuringData[toKey(element.pointCode, element.pointNumber)] = []
    }
    allMeasuringData[toKey(element.pointCode, element.pointNumber)] = allMeasuringData[toKey(element.pointCode, element.pointNumber)].concat(element.data.data)
  }
  if (new Date(res.data[0].data.endTime).getTime() - new Date(endTime).getTime() !== 0) {
    //一直load数据
    loadAllMeasuringData(
      measures,
      res.data[0].data.endTime,
      endTime,
      allMeasuringData
    )
  }
  else {
    console.log(allMeasuringData)
    return allMeasuringData
  }
}

function toKey (pointCode, pointNumber) {
  return pointCode + '_' + pointNumber
}

export default {

  /**
   * 查询物业的场地租赁情况
   */
  getAreaDataForProperty () {
    return new Promise((resolve, reject) => {
      const apiArr = [api.rentalArea.getRentalAreaTrusteeshipContractForProperty(0, null, null, null, null, null, 1), api.rentalArea.getLeaseContractForProperty(0, -1, null, null, null, null, null, 1)]

      Promise.all(apiArr).then(resArr => {
        // 获取当前物业所有场地的数据
        let areaData = []
        if (resArr[0].success && resArr[0].data) {
          for (let i = 0; i < resArr[0].data.length; i++) {
            const item = resArr[0].data[i]
            for (let j = 0; j < item.areas.length; j++) {
              const areaItem = item.areas[j]
              areaData.push({
                id: areaItem.id,
                name: areaItem.name,
                startTime: item.startTime,
                endTime: item.endTime,
                leaseStartTime: null,
                leaseEndTime: null,
                place: areaItem.place,
                area: areaItem.area,
                state: 0,
                stateLabel: '未租赁'
              })
            }
          }
        }
        // 获取当前物业所有场地的租赁情况
        if (resArr[1].success && resArr[1].data) {
          for (let i = 0; i < resArr[1].data.length; i++) {
            const item = resArr[1].data[i]
            for (let j = 0; j < item.areas.length; j++) {
              const areaItem = item.areas[j]
              // 查找物业对应的场地
              const index = areaData.findIndex(c => c.id === areaItem.id)
              if (index > -1) {
                let date = new Date()
                date.setHours(0)
                date.setMinutes(0)
                date.setSeconds(0)
                date.setMilliseconds(0)
                if (new Date(item.endTime).getTime() >= date.getTime() && new Date(item.startTime).getTime() <= date.getTime()) {
                  areaData[index].leaseStartTime = item.startTime
                  areaData[index].leaseEndTime = item.endTime
                  areaData[index].state = 1
                  areaData[index].stateLabel = '已租赁'
                }
              }
            }
          }
        }

        resolve(areaData)
      })
    })
  },

  /**
   * 获取业主已托管场地列表
   */
  getAreaDataInHosting () {
    return new Promise((resolve, reject) => {
      api.rentalArea.getRentalAreaTrusteeshipContractForProprietor(0, null, null, null, null, null, 1).then(res => {
        let tableData = []
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            const element = res.data[i];
            let date = new Date()
            date.setHours(0)
            date.setMinutes(0)
            date.setSeconds(0)
            date.setMilliseconds(0)
            if (new Date(element.endTime).getTime() >= date.getTime() && new Date(element.startTime).getTime() <= date.getTime()) {
              for (let j = 0; j < element.areas.length; j++) {
                const areaItem = element.areas[j];
                const item = tableData.find(c => c.id == areaItem.id)
                if (!item) {
                  tableData.push(areaItem)
                }
              }
            }
          }
        }
        res.data = tableData
        resolve(res)
      })
    })
  },
  /**
   * 获取物业已租赁的场地列表
   */
  getAreaDataInLease () {
    return new Promise((resolve, reject) => {
      api.rentalArea.getLeaseContractForProperty(0, -1, null, null, null, null, null, 1).then(res => {
        let tableData = []
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            const element = res.data[i];
            let date = new Date()
            date.setHours(0)
            date.setMinutes(0)
            date.setSeconds(0)
            date.setMilliseconds(0)
            if (new Date(element.endTime).getTime() >= date.getTime() && new Date(element.startTime).getTime() <= date.getTime()) {
              for (let j = 0; j < element.areas.length; j++) {
                const areaItem = element.areas[j];
                const item = tableData.find(c => c.id == areaItem.id)
                if (!item) {
                  tableData.push(areaItem)
                }
              }
            }
          }
        }
        res.data = tableData
        resolve(res)
      })
    })
  },

  /**
   * 获取运行分析数据
   * @param {*} measureId 测点Id
   * @param {*} point [{pointCode,pointNumber}]
   * @param {*} type 类型  1为统计   2.为采集间隔
   * @param {*} dateType 时间类型 hour 按时  day 按天  如果类型为1 则不能为null
   */
  getRunningAnalyseChartData (measureId, point, type, dateType, startTime, endTime) {
    return new Promise(async (resolve, reject) => {
      if (type == 2) {
        // 按采集间隔
        let measures = []
        let measuringData = {}
        for (let i = 0; i < point.length; i++) {
          const pointItem = point[i];
          measures.push({
            measureId: measureId,
            pointNumber: pointItem.pointNumber,
            pointCode: pointItem.pointCode,
          })
          measuringData[toKey(pointItem.pointCode, pointItem.pointNumber)] = []
        }
        // 递归获取采集间隔数据
        const data = await loadAllMeasuringData(measures, startTime, endTime, measuringData)
        resolve({ data: data })
      }
      else {
        let apiArr = []
        // 统计数据项的参数
        let quantityMeasures = []
        // 采集数据项的参数
        let measuringMeasures = []
        let apiTypeData = []
        let quantityData = {}
        for (let i = 0; i < point.length; i++) {
          const pointItem = point[i];
          quantityData[toKey(pointItem.pointCode, pointItem.pointNumber)] = []
          const type = getPointCodeDataType(point[i].pointCode)
          if (type == 'quantity') {
            quantityMeasures.push({
              measureId: measureId,
              pointNumber: pointItem.pointNumber,
              pointCode: pointItem.pointCode,
            })
            apiTypeData.push("quantity" + dateType)
          } else {
            measuringMeasures.push({
              measureId: measureId,
              pointNumber: pointItem.pointNumber,
              pointCode: pointItem.pointCode,
            })
            apiTypeData.push("measuring")
          }
        }

        if (dateType === 'hour') {
          if (quantityMeasures.length > 0) {
            apiArr.push(api.quantity.getQuantityHour2(quantityMeasures, startTime, endTime, null))
          }
          if (measuringMeasures.length > 0) {
            apiArr.push(api.measuring.getMeasuringValueHour2(measuringMeasures, startTime, endTime, 0))
          }
        }
        else {
          if (quantityMeasures.length > 0) {
            apiArr.push(api.quantity.getQuantityDay3(quantityMeasures, startTime, endTime, null))
          }
          if (measuringMeasures.length > 0) {
            apiArr.push(api.measuring.getMeasuringValueDay2(measuringMeasures, startTime, endTime, 0))
          }
        }

        Promise.all(apiArr).then(resArr => {
          for (let i = 0; i < resArr.length; i++) {
            const res = resArr[i];
            const type = apiTypeData[i]

            // 对不同的接口进行不同的处理
            if (type == 'measuring') {
              for (let j = 0; j < res.data.length; j++) {
                const item = res.data[j];
                quantityData[toKey(item.pointCode, item.pointNumber)] = item.data.data
              }
            }
            else if (type == 'quantityhour') {
              for (let j = 0; j < res.data.length; j++) {
                const item = res.data[j];
                quantityData[toKey(item.pointCode, item.pointNumber)] = item.data
              }
            }
            else if (type == 'quantityday') {
              for (let j = 0; j < res.data.length; j++) {
                const item = res.data[j];
                quantityData[toKey(item.pointCode, item.pointNumber)] = item.data[0]
              }
            }
            else {

            }

            let thisVal = {}
            if (quantityMeasures.length > 0) {
              api.quantity.getQuantity2(quantityMeasures, startTime, endTime, 0).then(res2 => {
                for (let k = 0; k < res2.data.length; k++) {
                  const element = res2.data[k];
                  thisVal[toKey(element.pointCode, element.pointNumber)] = element.value
                }
                resolve({ data: quantityData, thisVal: thisVal })
              })
            }
            else {
              resolve({ data: quantityData, thisVal: thisVal })
            }
          }
        })
      }
    })
  },
  /**
   * 获取运行分析tabData
   * @param {*} measureId 测点Id
   * @param {*} paramTabData 自定义页面参数
   */
  getRunningAnalyseTabData (measureId, paramTabData = []) {
    return new Promise((resolve, reject) => {
      api.measure.getMeasuresExpressions(JSON.stringify([measureId])).then(res => {

        if (!res.success) {
          resolve({ data: res.errorStr })
          return
        }
        let tabData = []
        let allExpData = []
        // 获取所有数据项
        for (let i = 0; i < res.data[0].expressionGroups.length; i++) {
          const group = res.data[0].expressionGroups[i];
          for (let j = 0; j < group.expression.length; j++) {
            const exp = group.expression[j];
            group.expression[j].dataType = getPointCodeDataType(exp.pointCode)
            // 是否可添加tab
            const bolAddTab = judgePointCode(exp.pointCode)
            if (bolAddTab) {
              allExpData.push(exp)
            }
          }
        }

        // 获取自定义组合的tab
        for (let i = 0; i < paramTabData.length; i++) {
          const paramTab = paramTabData[i]
          let tabExpData = []
          for (let j = 0; j < paramTab.point.length; j++) {
            for (let k = 0; k < allExpData.length; k++) {
              const exp = allExpData[k]
              if (exp.pointCode == paramTab.point[j].pointCode) {
                if (paramTab.point[j].pointNumber == "-" || paramTab.point[j].pointNumber == paramTab.point[j].pointNumber) {
                  // 设置单位 
                  exp.unit = paramTab.point[j].unit
                  tabExpData.push(exp)
                  // 判断该公式是否已经在自定义参数里面包含
                  allExpData[k].use = true
                }
              }
            }
          }
          if (tabExpData.length > 0) {
            const tabItem = new TabItem("tab" + i, paramTab.name, tabExpData)
            tabData.push(tabItem)
          }
        }

        for (let i = 0; i < allExpData.length; i++) {
          if (!allExpData[i].use) {
            const tabItem = new TabItem(allExpData[i].name, allExpData[i].displayName, [allExpData[i]])
            tabData.push(tabItem)
          }
        }
        resolve({ data: tabData })
      })
    })
  },
}